import { analytics } from '@/lib/analytics'
import { PAGE_PATH } from '@/lib/page-paths'
import { AppDispatch } from '@/lib/store'
import { toast } from 'react-toastify'
import { userApi } from './userApi'

// Trigger a quota refetch via RTK-Query
export const refreshQuota = () => (dispatch: AppDispatch) => {
  dispatch(userApi.endpoints.getUserQuota.initiate())
}

// Sign-out helper used by components/middleware that still expect a thunk signature
export const signOut =
  (shouldRedirect: boolean = true) =>
  async (dispatch: AppDispatch) => {
    try {
      analytics.userLifecycle.logout()
      await dispatch(userApi.endpoints.signOut.initiate()).unwrap()

      if (shouldRedirect) {
        window.location.href = PAGE_PATH.HOME
      } else {
        window.location.reload()
      }
    } catch (error) {
      console.error('Error signing out:', error)
      toast.error('Failed to sign out. Please try again.')
    }
  }
